import AuthController from '../domain/controller.js'

async function getUserData(context) {
  const { localRepo } = context
  const userData = await AuthController.getUserData(localRepo)
  return userData || null
}

export default getUserData
